import { createActionFactory } from '../../../../../common/redux';
const { createAction, createApiFailureAction } = createActionFactory('AuthApp => ');

const bootstrap = createAction(
  'bootstrap form values',
  (
    userFieldName,
    userFieldValue,
    passwordFieldName,
    passwordFieldValue,
    rememberMeFieldName,
    rememberMeFieldValue,
    totpCodeFieldName,
    totpCodeFieldValue,
    cesSupportUrl
  ) => ({
    userFieldName,
    userFieldValue,
    passwordFieldName,
    passwordFieldValue,
    rememberMeFieldValue,
    rememberMeFieldName,
    totpCodeFieldName,
    totpCodeFieldValue,
    cesSupportUrl,
  })
);

const updateField = createAction('update form values', (fieldId, value) => ({ fieldId, value }));
const forgetPasswordRedirect = createAction('forgotten password redirect request');

const onLoginRequest = createAction('login request', (formRef, isValid) => ({ formRef, isValid }));
const onLoginRequestSuccess = createAction('login success');
const onLoginRequestFailure = createApiFailureAction('login failure');

const onEmailSubmitRequest = createAction('email submit request');
const onEmailSubmitRequestSuccess = createAction(
  'email submit request success',
  (loginType, secondaryLoginType, skipCountdown, cesSupportUrl, cesAuthLoginUrl) => ({
    loginType,
    secondaryLoginType,
    skipCountdown,
    cesSupportUrl,
    cesAuthLoginUrl,
  })
);
const onEmailSubmitRequestFailure = createApiFailureAction('email submit request failure');

export default {
  bootstrap,
  updateField,
  forgetPasswordRedirect,

  onLoginRequest,
  onLoginRequestSuccess,
  onLoginRequestFailure,

  onEmailSubmitRequest,
  onEmailSubmitRequestSuccess,
  onEmailSubmitRequestFailure,
};
